/* eslint-disable @typescript-eslint/no-unused-vars */
// ---- Vite envs ----
const {
  VITE_API_BASE_URL,
  MODE,
  PROD,
  VITE_GOOGLE_MAPS_API_KEY
} = import.meta.env;


// helpers
const trimEnd = (s?: string, ch = '/') =>
  (s ?? '').endsWith(ch) ? (s ?? '').slice(0, -1) : (s ?? '');
const ensureEnd = (s?: string, ch = '/') =>
  (s ?? '').endsWith(ch) ? (s ?? '') : `${s ?? ''}${ch}`;

// Router basename should END with a slash when hosted under a subpath
const routerBase = ensureEnd('/');

// API base should NOT end with a slash (so `${baseUrl}/x` is clean)
const apiBase = trimEnd(VITE_API_BASE_URL || 'https://localhost:7110');

export const environment = {
  name: MODE || 'development',
  production: Boolean(PROD),
  routerBase,
  baseUrl: apiBase,
  GoogleApiKey: VITE_GOOGLE_MAPS_API_KEY
} as const;
